import * as _ from 'lodash';
import { PnEvents } from '../../../../realtime';
import { RootScopeEvents } from '../../root-scope-types';
import { TraceEvents } from './call-trace-event';
import { CallTrace } from './call-trace';
import { StateWatcher } from './state-watcher';
import { createLogger } from '../../../../utility/datadog-util';
export default class CallTraceService {
    constructor($injector) {
        this.traces = [];
        this.track = (name, data) => {
            const lastTrace = this.getLastCallTrace();
            if (lastTrace?.isActive()) {
                lastTrace.track(name, data);
            }
        };
        this.$rootScope = $injector.get('$rootScope');
        const stateWatcher = StateWatcher.getInstance($injector);
        // rootScope
        _.each({
            [RootScopeEvents.COMMUNICATION_CONTROL.PHONE_START]: TraceEvents.Init,
            [RootScopeEvents.COMMUNICATION_CONTROL.ANSWER_PHONE]: TraceEvents.Init,
            [RootScopeEvents.PHONE.STARTED]: TraceEvents.SessionCreated,
            [RootScopeEvents.ACTIVE_PROVIDER.CONNECTION_CREATED]: TraceEvents.ConnectionCreated,
            [RootScopeEvents.ACTIVE_PROVIDER.CONNECTION_DESTROYED]: TraceEvents.ConnectionDestroyed,
            [RootScopeEvents.SUBSCRIBER.PARTICIPANT_VIDEO_APPEARED]: TraceEvents.ParticipantVideoAppeared,
            [RootScopeEvents.ACTIVE_PROVIDER.FIRST_PARTICIPANT_APPEARED]: TraceEvents.ParticipantAppeared,
            [RootScopeEvents.ACTIVE_PROVIDER.SESSION_DISCONNECTED]: TraceEvents.SessionDisconnected,
            [RootScopeEvents.COMMUNICATION_CONTROL.PHONE_STOP]: TraceEvents.End,
            [RootScopeEvents.COMMUNICATION_CONTROL.DO_RESTART]: TraceEvents.Restart,
        }, (name, event) => {
            if (name === TraceEvents.Init) {
                this.$rootScope.$on(event, (e, person) => {
                    const logger = this.createLogger(stateWatcher);
                    this.traces.push(new CallTrace(person, logger));
                });
            }
            else {
                this.$rootScope.$on(event, (e, data) => this.track(name, data));
            }
        });
        // pn
        const pn = $injector.get('pn');
        _.each({
            [PnEvents.Leave]: TraceEvents.PnPersonLeft,
            [PnEvents.Join]: TraceEvents.PnPersonJoin,
        }, (name, event) => {
            pn.on(event, (person) => this.track(name, { person }));
        });
    }
    createLogger(stateWatcher) {
        const userInfo = stateWatcher.getUserInfo();
        const context = {
            timer: 'callInit',
            role: userInfo.userType,
            userId: userInfo.userId,
            plan: userInfo.planType,
            vendor: 'Vonage',
        };
        return createLogger('callInitTimer', { context });
    }
    getLastCallTrace() {
        return this.traces[this.traces.length - 1];
    }
}
